import { useEffect, useState } from "react";
import { Button, Modal, Row, Col } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../app/store";
import {
  addSalaryType,
  deleteSalaryType,
  getSalaryTypes,
  toggleSalaryTypeStatus,
} from "../../features/jobSlice";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const SalaryType = () => {
  const dispatch = useAppDispatch();
  const [show, setShow] = useState(false);
  const [executed, setExecuted] = useState(false);
  const [SalaryType, setSalaryType] = useState("");
  const [searchTerm, setSearchTerm] = useState(""); // New search state

  const { salaryTypes } = useAppSelector((state) => state.job);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    dispatch(getSalaryTypes());
  }, [dispatch, executed]);

  const handleSaveJobType = () => {
    let data = {
      name: SalaryType,
      status: true,
    };
    dispatch(addSalaryType(data))
      .unwrap()
      .then(() => {
        setSalaryType("");
        handleClose();
        setExecuted(!executed);
        toast.success("Salary type added successfully!");
      })
      .catch((error) => {
        toast.error("Failed to add salary type:", error);
      });
  };

  const handleToggle = (id: any, status: any) => {
    const data = {
      id,
      status: !status,
    };

    dispatch(toggleSalaryTypeStatus(data))
      .unwrap()
      .then(() => {
        setExecuted(!executed);
        toast.success("Salary type status updated successfully!");
      })
      .catch((error) => {
        toast.error("Failed to update salary type status: " + error.message);
      });
  };

  const handleDelete = (id: number) => {
    dispatch(deleteSalaryType(id))
      .unwrap()
      .then(() => {
        setExecuted(!executed);
        toast.success("Salary type deleted successfully!");
      })
      .catch((error) => {
        toast.error("Failed to delete salary type: " + error.message);
      });
  };

  // Filter salary types
  const filteredSalaryTypes = salaryTypes?.filter((item: any) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Row>
        <Col md={9} sm={12} className="p-3">
          <div className="d-flex flex-row justify-content-between pt-3">
            <div>
              <Button
                variant="secondary"
                className="rounded-0 text-white"
                onClick={handleShow}
              >
                Add Salary Type
              </Button>
            </div>
            <div>
              <div
                className="input-group rounded border border-secondary-subtle shadow-sm"
                style={{ maxWidth: "300px" }}
              >
                <span className="input-group-text bg-white border-0">
                  <i className="bi bi-search text-muted"></i>
                </span>
                <input
                  type="text"
                  className="form-control border-0"
                  placeholder="Search"
                  aria-label="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>
          <hr />
          <div className="job-settings-table">
            <Row className="mt-2 bg-primary text-white p-3 rounded">
              <div className="d-flex flex-row justify-content-between">
                <Col md={4}>Payment Type</Col>
                <Col md={4}>Enable/Disable</Col>
                <Col md={4}>Action</Col>
              </div>
            </Row>

            {filteredSalaryTypes && filteredSalaryTypes.length > 0 ? (
              filteredSalaryTypes.map((item: any) => (
                <Row
                  key={item.id}
                  className="mt-2 bg-white text-dark p-3 rounded col-rows"
                >
                  <Col md={4}>{item.name}</Col>
                  <Col md={4}>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id={`flexSwitchCheckChecked-${item.id}`}
                        checked={item.status}
                        onChange={() => handleToggle(item.id, item.status)}
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <a href={`salary-type/${item.id}`}>
                      <i className="bi bi-pencil-square"></i>
                    </a>
                    <i
                      className="bi bi-trash text-danger ms-3"
                      onClick={() => handleDelete(item.id)}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </Col>
                </Row>
              ))
            ) : (
              <div className="text-center text-muted mt-3">
                No salary types added
              </div>
            )}
          </div>
        </Col>
        <Col md={3} sm={12} style={{ backgroundColor: "#C2CFE0" }}>
          <div className="p-3">
            <div className="mb-2">
              <h5>Configure your Job Type</h5>
            </div>
            <p>
              Do you wish to send a warm and personalized acknowledgement email
              to every candidate who applies to your company? Do you wish to
              send a policy guide to help any employee who requests a transfer?
              Email notifications help you customize (almost) every email that
              is sent from Freshteam to candidates, employees, managers etc.
            </p>
          </div>
        </Col>
      </Row>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title>
            <h3 className="title-modal">ADD NEW PAYMENT TYPE</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label className="mb-2"> Payment/Salary Type</label>
            <input
              type="text"
              className="form-control form-control-lg rounded-0"
              name="salary-type"
              value={SalaryType}
              onChange={(e) => setSalaryType(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 d-flex justify-content-between">
          <Button variant="danger" className="rounded-0" onClick={handleClose}>
            Cancel
          </Button>

          <Button
            variant="secondary"
            className="text-white rounded-0"
            onClick={handleSaveJobType}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SalaryType;
